import Button from "@/components/button"
import Space from "@/components/space"
import { Notification } from "@/entities/notification/model/notification.types"
import getColor from "@/utils/get-color.utils"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"

interface Props {
  isPrimary?: boolean
  notification: Notification
}

const owlAddTaskImage = require("@/assets/owl-add-task.png")

export default function NotificationCard({ isPrimary = false, notification }: Props) {
  function handleClick() {
    notification.onClick?.()
  }

  return (
    <div
      className="mx-[30px] mb-[30px] rounded-[12px] bg-white p-20 shadow-sm _hover"
      onClick={handleClick}
      style={{
        backgroundImage: isPrimary ? `url(${owlAddTaskImage})` : undefined,
        backgroundPosition: "left 4px bottom -18px",
        backgroundRepeat: "no-repeat",
        backgroundSize: "88px auto",
        border: "1px solid #E5E7EB"
      }}>
      {notification.context && <div className="grey-t mb-10 font-bold">{notification.context}</div>}

      <div className="flex items-center gap-10">
        <div
          className="flex h-[26px] w-[26px] shrink-0 rounded-full"
          style={{ backgroundColor: getColor(notification.color) }}>
          <FontAwesomeIcon icon={notification.icon} className="m-auto text-white text-sm" />
        </div>
        <div className="min-w-0" style={{ color: getColor(notification.color) }}>
          <b>{notification.title}</b>
        </div>
      </div>

      <div className="my-10">{notification.text}</div>
      <div className="flex mt-[6px] -mb-[6px]">
        <Space />
        <Button
          isFullWidth
          isWithBorder
          className={isPrimary ? "primary" : ""}
          onClick={(e) => {
            e.stopPropagation()
            handleClick()
          }}>
          {notification.cta}
        </Button>
      </div>
    </div>
  )
}
